import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ConfirmProvider, ToastProvider } from "./components/ui";
import { ApiError } from "./lib/api";
import { queryClient } from "./lib/query-client";
import { initTheme } from "./lib/theme";
import { router } from "./router";
import "./styles/app.css";

queryClient.getQueryCache().subscribe((event) => {
  const error = event.query.state.error;
  if (error instanceof ApiError && error.status === 401 && router.state.location.pathname !== "/login") {
    router.navigate({ to: "/login" });
  }
});

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root");

initTheme();

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <ConfirmProvider>
          <RouterProvider router={router} />
        </ConfirmProvider>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
